import {v3} from "../short3.js";
import SceneWkfg2Importer from "oc-app/scene/SceneWkfg2Importer";

/**
 * zeigt ein Kugel-Raster an, das verschiedene Materialparameter zeigt, um Lichtsetup zu eichen
 */
export default class OcMaterialHelper extends THREE.Group {

    constructor(size = 1) {
        super();
        const count = 7;

        this.sceneImporter = new SceneWkfg2Importer(APP.settings.wkfgContentBaseUrl);

        this.addLuminescenceRoughnessRaster(count,size*0.4, 0, v3(0,0,0));
        this.addLuminescenceRoughnessRaster(count, size*0.4, 1, v3(size*0.5,0,0));
        this.addHueLuminescenceRaster(count, size*0.4, 0.5, v3(0,size*0.5,0));
        this.addHueLuminescenceRaster(count, size*0.4, 1, v3(size*0.5,size*0.5,0));

        this.showDomHelper();
    }

    showDomHelper() {
        const e = $(`<div style="position:absolute;right:2px;top:2px;width:200px;height:200px;z-index:10000;border:1px solid red;">`);
        $('body').append(e);
        this.children.forEach(c=>{
            const x = 100*c.position.x;
            const y = 100*(1-c.position.y);
            const w = 100 / 8;
            const color = c.material.color.clone();
            if (STAGE.settings.renderer.pbrPipeline) {
                color.convertLinearToSRGB();
            }
            const colorHex = color.getHexString();
            e.append($(`<div style="position:absolute;left:${x}%;top:${y}%;width:${w}%;height:${w}%;background-color:#${colorHex}">`));
        });
    }

    addHueLuminescenceRaster(count,size,saturation,positionOffset) {
        const countY = count-1;
        const countX = count;
        const sphereSize = size / countY;
        const roughness = 0.7;
        this.range(0, 1, countX, (from, to, count, luminescence) => {
            this.range(0, 1, countY, (from, to, count, hue) => {
                const color = this.color(hue, saturation, luminescence);
                this.setPosition(this.addSphere(sphereSize * 0.5, this.standardMaterial(color, 0, roughness)), v3(luminescence * size, hue * (size-sphereSize) + sphereSize, 0).add(positionOffset));
            });
            const color = this.color(0, saturation, luminescence);
            this.setPosition(this.addSphere(sphereSize * 0.5, this.basicMaterial(color)), v3(luminescence * size,sphereSize * count , 0).add(positionOffset).add(v3(0, sphereSize*0.1,0)));
        });
    }

    addLuminescenceRoughnessRaster(count,size,metalness,positionOffset) {
        const countY = count-1;
        const countX = count;
        const sphereSize = size / countY;
        this.range(0, 1, countX, (from, to, count, luminescence) => {
            const color = this.color(0, 0, luminescence);
            this.range(1, 0, countY, (from, to, count, roughness) => {
                this.setPosition(this.addSphere(sphereSize * 0.5, this.standardMaterial(color, metalness, roughness)), v3(luminescence * size, roughness * (size-sphereSize) + sphereSize, 0).add(positionOffset));
            });
            this.setPosition(this.addSphere(sphereSize * 0.5, this.basicMaterial(color)), v3(luminescence * size,sphereSize * count , 0).add(positionOffset).add(v3(0, sphereSize*0.1,0)));
        });
    }

    setPosition(object, position) {
        object.position.copy(position);
        return object;
    }

    color(h, s, l) {
        const color = new THREE.Color().setHSL(h, s, l);
        if (STAGE.settings.renderer.pbrPipeline) {
            color.convertSRGBToLinear();
        }
        return color;

    }

    basicMaterial(color) {
        return new THREE.MeshBasicMaterial({color, shading: THREE.SmoothShading});
    }

    standardMaterial(color, metalness, roughness) {
        return new THREE.MeshStandardMaterial({color, metalness, roughness, shading: THREE.SmoothShading, envMap: this.sceneImporter.getStandardEnvMap()});
    }

    addSphere(size, material) {
        const sphere = Scenes.sphere(size, material);
        this.add(sphere);
        return sphere;
    }

    range(from, to, count, iterator) {
        for (let i = 0; i < count; i++) {
            const fraction = i / (count - 1);
            const lerp = (to - from) * fraction + from;
            iterator(from, to, count, lerp, i);
        }
    }

}
